import React from "react";
import type { SwitchStatItem, SwitchStatsSection } from "./comparison-types";
import "../styles/datadog-switch-stats.module.scss";

export type VendorSwitchStatsProps = {
  className?: string;
  content: SwitchStatsSection;
};

const SwitchStatCard: React.FC<{ stat: SwitchStatItem }> = ({ stat }) => (
  <article className="switch-stat-card">
    <p className="switch-stat-value">
      <span className="switch-stat-number">{stat.value}</span>
      <span className="switch-stat-unit">{stat.unit}</span>
    </p>
    <div className="switch-stat-copy">
      <h3 className="switch-stat-title">{stat.title}</h3>
      <p className="switch-stat-description">{stat.description}</p>
    </div>
  </article>
);

const VendorSwitchStats: React.FC<VendorSwitchStatsProps> = ({
  className = "",
  content,
}) => (
  <section
    className={`datadog-switch-stats vendor-switch-stats ${className}`.trim()}
    aria-label={content.title}
  >
    <div className="switch-stats-bg" aria-hidden="true" />
    <div className="container">
      <div className="section-tag">{content.tag}</div>

      <div className="switch-stats-header">
        <h2 className="switch-stats-title">{content.title}</h2>
        <p className="switch-stats-description">{content.description}</p>
      </div>

      <div className="switch-stats-cards">
        {content.stats.map((stat) => (
          <SwitchStatCard stat={stat} key={stat.id} />
        ))}
      </div>
    </div>
  </section>
);

export default VendorSwitchStats;
